module.exports = "<div>\n  <h3>Ouch!</h3>\n  <p><%= message %></p>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/overrides/clappr/plugins/error_screen/public/error_screen.html
// module id = 292
// module chunks = 0